function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.99979919,19.9996 C6.89479919,19.9996 5.99779919,19.1416 5.99779919,18.0826 L10.0017992,18.0826 C10.0017992,19.1416 9.10479919,19.9996 7.99979919,19.9996 Z M15.9304992,16.275 C16.1264992,16.601 15.8804992,17 15.4954992,17 L0.503499191,17 C0.118499191,17 -0.127500809,16.601 0.0694991915,16.275 C0.549499191,15.477 0.999499191,13.972 0.999499191,13.05 L0.999499191,8 C0.999499191,5.183 2.78949919,2.716 5.53449919,2.167 C5.53449919,2.167 5.72549919,2.145 6.01149919,2.118 C6.00949919,2.078 5.99949919,0 7.99949919,0 C9.99949919,0 9.99049919,2.078 9.98849919,2.118 C10.2744992,2.145 10.4654992,2.167 10.4654992,2.167 C13.2094992,2.716 14.9994992,5.183 14.9994992,8 L14.9994992,13.051 C14.9994992,13.972 15.4504992,15.477 15.9304992,16.275 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/notification.40beec23.svg";
export { SvgComponent as ReactComponent };